import { Profile } from '../profile';

const ProfilePage = () => {
  return <Profile />;
};

export default ProfilePage;
